import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Eye, LogOut, Timer, Lock, MessageCircle } from "lucide-react";
import { toast } from "sonner";

export function ImpersonationBar({ shopName }) {
  const exit = async () => {
    try { await api.post("/auth/impersonate-exit"); window.location.href = "/admin"; }
    catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div data-testid="impersonation-bar" className="sticky top-0 z-[60] bg-fuchsia-700 text-white text-sm px-4 py-2 flex items-center justify-center gap-3">
      <Eye className="h-4 w-4 shrink-0" />
      <span className="truncate">Você está vendo como <b>{shopName}</b></span>
      <button type="button" data-testid="impersonation-exit" onClick={exit}
              className="shrink-0 inline-flex items-center gap-1 rounded-md bg-white/15 hover:bg-white/25 px-2.5 py-1 text-xs font-bold uppercase">
        <LogOut className="h-3.5 w-3.5" /> Sair
      </button>
    </div>
  );
}

export function TrialBanner({ shop }) {
  const [wa, setWa] = useState("");
  const st = shop?.plan_status;
  useEffect(() => {
    if (st === "teste" || st === "teste_vencido") {
      api.get("/support/info").then(({ data }) => setWa(data?.support_whatsapp || "")).catch(() => {});
    }
  }, [st]);
  if (st !== "teste" && st !== "teste_vencido") return null;
  const expired = st === "teste_vencido";
  const left = shop.trial_days_left;
  const msg = expired ? "Seu teste grátis terminou. O app está só para consulta — nada foi apagado."
    : left <= 0 ? "Seu teste grátis termina hoje." : `Seu teste grátis termina em ${left} dia${left > 1 ? "s" : ""}.`;
  const text = `Olá! Sou da oficina ${shop.name} e quero assinar o AutoOficina.`;
  const href = `https://wa.me/${wa ? (wa.length <= 11 ? `55${wa}` : wa) : ""}?text=${encodeURIComponent(text)}`;
  const Icon = expired ? Lock : Timer;
  return (
    <div data-testid="trial-banner" className={`mb-4 rounded-xl border px-4 py-3 flex flex-col sm:flex-row sm:items-center gap-3 ${expired ? "border-red-800 bg-red-950/30 text-red-200" : "border-sky-800 bg-sky-950/30 text-sky-100"}`}>
      <Icon className="h-5 w-5 shrink-0" />
      <span data-testid="trial-banner-text" className="flex-1 text-sm font-medium">{msg}</span>
      <a data-testid="trial-banner-whatsapp" href={href} target="_blank" rel="noopener noreferrer"
         className="inline-flex items-center justify-center gap-1.5 h-9 px-3 rounded-md bg-emerald-600 hover:bg-emerald-500 text-white text-xs font-bold uppercase">
        <MessageCircle className="h-4 w-4" /> Assinar / falar com o suporte
      </a>
    </div>
  );
}
